import React, { Component } from "react";
import Login from "./Login";

import "./AuthContainer.scss";
import ReactGA from "react-ga";
// import CompanyLogo from "../../assets/radarr-logo-black.png";
import MainImage from "./main-image1.png";
import { Switch, Link, Route } from "react-router-dom";
import SignUp from "./SignUp/SignUp";
import ForgetPassword from "./ForgetPassword/ForgetPassword";
import ResetPassword from "./ResetPassword/ResetPassword";
import EmailVerification from "./emailVerification/EmailVerification";
import AuthLinkedin from "./authLinkedin/AuthLinkedin";
// import PageNotFound from "../PageNotFound/PageNotFound";
import { ReactComponent as RadarrLogo } from "../../assets/radarr-logo-green.svg";
import Scrollbars from "react-custom-scrollbars";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { updateRouteValues } from "../../actions/globalAction";

class AuthContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (zE) {
            zE("webWidget", "updateSettings", { color: { theme: "#00bfa3" } });
            zE("webWidget", "show");
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname != window.location.pathname) {
            let route = {
                to: window.location.pathname,
                from: prevProps.location.pathname,
            };
            this.props.updateRouteValues(route);
        }
    }

    componentWillUnmount() {
        zE("webWidget", "hide");
    }

    render() {
        return (
            <div className="auth-container">
                <div className="auth-navbar">
                    <RadarrLogo />
                    {/* {this.props.location.pathname.includes("/signup") ? (
                        <Link to="/signin">
                            <div className="navbar-button">Sign In</div>
                        </Link>
                    ) : (
                        <Link to="/signup">
                            <div className="navbar-button">Sign Up</div>
                        </Link>
                    )} */}
                </div>
                <div className="auth-contents">
                    <div className="auth__left-wrap">
                        <div className="main-text">
                            <p>A powerful social media intelligence tool</p>
                            <p>that helps you listen, monitor and track online conversations easily.</p>
                        </div>
                        <div className="main-image">
                            <img src={MainImage} />
                        </div>
                        <p style={{ color: "#fff", paddingLeft: "30px" }}>Radarr helps 1000+ brands globally get actionable insights</p>
                        <div className="company-logos">
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/discovery-networks-logo.png" alt="Discovery" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/twitter-logo.png" alt="X" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/glico-logo.png" alt="Glico" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/quantum-logo.png" alt="Quantum" />
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/toyota-logo-1.png" alt="Toyota" />
                            {/* <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/hong-leong-bank-logo.png" alt="Toyota" /> */}
                            <img src="https://d1u68zc0161z8s.cloudfront.net/wp-content/uploads/2021/07/mapletree-logo.png" alt="Mapletree" />
                        </div>
                    </div>
                    <div className="auth-right">
                        <Scrollbars
                            autoHide
                            renderView={(props) => <div {...props} className={`auth-scrollbar-view ${isMobile ? "auth-scrollbar-view-mobile" : ""}`} />}>
                            <Switch>
                                {/* <Route path="/signin" component={Login} /> */}
                                {/* <Route path="/signup" component={SignUp} /> */}
                                <Route path="/forgetpassword" component={ForgetPassword} />
                                <Route path="/resetpassword" component={ResetPassword} />
                                <Route path="/email-verify" component={EmailVerification} />
                                <Route path="/oauth-linkedin" component={AuthLinkedin} />
                            </Switch>
                            <div className="privacy__policy">
                                <a href="https://www.radarr.com/terms-of-use/" target="_blank" rel="noreferrer">
                                    <span className="privacy__text">Terms and Conditions </span>
                                </a>{" "}
                                <span className="privacy__text-separate"> | </span>{" "}
                                <a href="https://www.radarr.com/privacypolicy" target="_blank" rel="noreferrer">
                                    {" "}
                                    <span className="privacy__text">Privacy Policy </span>
                                </a>
                            </div>
                        </Scrollbars>
                    </div>
                </div>
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        updateRouteValues: (args) => dispatch(updateRouteValues(args)),
    };
};

export default connect(null, mapDispatchToProps)(AuthContainer);
